
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28823_227)","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M57.125 62.125H6.875a5 5 0 01-5-5V6.875a5 5 0 015-5h50.25a5 5 0 015 5v50.25a5 5 0 01-5 5z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M1.875 16.875H28.25l7.5-5h26.375","stroke":"#fff"}}),_c('path',{attrs:{"d":"M49.5 54.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM32 54.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM14.5 54.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM14.5 47V24.5M32 47V24.5M49.5 47V24.5M10.75 29.5h7.5M28.25 39.5h7.5M45.75 29.5h7.5","stroke":"#56BFC7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28823_227"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    